<template>
  <div class="language-switcher" role="group" :aria-label="$t('common.language')">
    <button
      v-for="item in supportedLocales"
      :key="item.code"
      type="button"
      :class="{ active: $i18n.locale === item.code }"
      :aria-pressed="$i18n.locale === item.code"
      :aria-label="item.label"
      :title="item.label"
      :lang="item.tag"
      @click="changeLanguage(item.code)"
    >
      <img :src="flags[item.code]" alt="" aria-hidden="true" width="24" height="16" />
    </button>
  </div>
</template>

<script>
import { setLocale, supportedLocales } from "../i18n";
import { retryTranslations } from "../i18n/content";
import portugalFlag from "../assets/flags/pt.svg";
import britishFlag from "../assets/flags/en.svg";
import frenchFlag from "../assets/flags/fr.svg";

export default {
  name: "LanguageSwitcher",
  setup() {
    return { supportedLocales, flags: { pt: portugalFlag, en: britishFlag, fr: frenchFlag } };
  },
  methods: {
    changeLanguage(code) {
      setLocale(code);
      retryTranslations();
    },
  },
};
</script>

<style scoped>
.language-switcher {
  display: inline-flex;
  align-items: center;
  gap: 1px;
  flex-shrink: 0;
  margin-left: 6px;
}
button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 30px;
  border: 1px solid transparent;
  border-radius: 6px;
  background: transparent;
  padding: 1px;
  cursor: pointer;
}
button:hover, button.active { border-color: #078391; background: #e7f8fa; }
button:focus-visible { outline: 3px solid #f5a623; outline-offset: 2px; }
img { display: block; border-radius: 2px; box-shadow: 0 0 0 1px rgb(0 0 0 / 12%); }
@media (min-width: 1200px) {
  .language-switcher { order: 2; }
}
@media (max-width: 1199.98px) {
  button { height: 36px; }
}
</style>
